module.exports = __webpack_public_path__ + "img/funds-line.4c7a2fa2.svg";